/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import AddToCartButton from '../../../Store/AddToCartButton';

class Download extends React.Component{

  logAnalyticsIfNeeded = (e) => {
    if (typeof global.gtag !== 'undefined') {
      gtag('event', 'file_download', {
        file_title: this.props.file.get('title') + ' - ' + this.props.file.get('display_date'),
        file_name: this.props.file.get('details').original_filename,
        file_id: this.props.file.get('id'),
        file_extension: this.props.file.get('extension')
      });
    }
  };

  render(){
    const linkDownload = this.props.file && this.props.file.get('remote_url') && this.props.file.get('remote_url').indexOf('tulix.tv') < 0;
    let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_files').indexOf(this.props.file.get('id')) >= 0;
    const filePrivate = this.props.file.get('visibility') === 'private';
    return <div style={{textAlign: 'center', margin: 8}}>
      {filePrivate && !userOwned ? <AddToCartButton
        title={this.props.file.get('title')}
        price={this.props.file.get('price')}
        id={this.props.file.get('id')}
        type="file"
        image={this.props.file.helper.featuredUrl(800)}
        owned={userOwned}
      /> : <a href={this.props.url} onClick={this.logAnalyticsIfNeeded} className="btn btn-primary" download={linkDownload ? this.props.name : false}>{FW.store.get('site').prop('download_files_title') ? FW.store.get('site').prop('download_files_title') : 'Download'}</a>}
    </div>;
  }
}

export default Download;
